(function () {
  'use strict';

  if (window.__TARA_POSTHOG_LOADED__) return;
  window.__TARA_POSTHOG_LOADED__ = true;

  var config = window.TARA_POSTHOG_CONFIG || {};
  if (!config.projectKey || !config.apiHost) return;

  var VERSION = '2026-10-07-kuwait-wa-1';
  var ATTRIBUTION_KEY = 'tara_attribution_v1';
  var SESSION_KEY = 'tara_attribution_session_v1';
  var POSTHOG_CART_SYNC_KEY = 'tara_posthog_cart_sync_v1';
  var VISITOR_ID_KEY = 'tara_visitor_id_v1';
  var SCROLL_DEPTHS = [25, 50, 75, 90];
  var scrollSeen = {};
  var sectionSeen = {};
  var oneTimeEvents = {};
  var eventQueue = [];
  var flushTimer = null;
  var MAX_BATCH_EVENTS = 8;
  var FLUSH_DELAY_MS = 1200;
  var lastAddToCartClickAt = 0;
  var lastCheckoutStartAt = 0;
  var CART_ATTRIBUTE_MAP = {
    first_landing_url: 'tara_first_landing_page',
    first_landing_path: 'tara_first_landing_path',
    first_referrer: 'tara_first_referrer',
    first_utm_source: 'tara_first_utm_source',
    first_utm_medium: 'tara_first_utm_medium',
    first_utm_campaign: 'tara_first_utm_campaign',
    first_utm_content: 'tara_first_utm_content',
    first_utm_term: 'tara_first_utm_term',
    first_utm_id: 'tara_first_utm_id',
    first_utm_adset_id: 'tara_first_utm_adset_id',
    first_utm_ad_id: 'tara_first_utm_ad_id',
    first_campaign_id: 'tara_first_campaign_id',
    first_adset_id: 'tara_first_adset_id',
    first_ad_id: 'tara_first_ad_id',
    last_landing_url: 'tara_last_landing_page',
    last_landing_path: 'tara_last_landing_path',
    last_referrer: 'tara_last_referrer',
    last_utm_source: 'tara_last_utm_source',
    last_utm_medium: 'tara_last_utm_medium',
    last_utm_campaign: 'tara_last_utm_campaign',
    last_utm_content: 'tara_last_utm_content',
    last_utm_term: 'tara_last_utm_term',
    last_utm_id: 'tara_last_utm_id',
    last_utm_adset_id: 'tara_last_utm_adset_id',
    last_utm_ad_id: 'tara_last_utm_ad_id',
    last_campaign_id: 'tara_last_campaign_id',
    last_adset_id: 'tara_last_adset_id',
    last_ad_id: 'tara_last_ad_id',
    last_fbclid: 'tara_fbclid',
    attribution_fbp: 'tara_fbp',
    attribution_fbc: 'tara_fbc'
  };

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    try {
      if (typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === false) {
        return false;
      }
      if (typeof privacy.currentVisitorConsent === 'function') {
        var consent = privacy.currentVisitorConsent();
        if (consent && consent.analytics === 'no') return false;
      }
    } catch (error) {
      return false;
    }
    return true;
  }

  function readJson(key, storage) {
    try {
      var value = (storage || window.localStorage).getItem(key);
      return value ? JSON.parse(value) : {};
    } catch (error) {
      return {};
    }
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'ta_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
  }

  // First-party message attribution. No identity merge, phone, email, or quiz answers.
  var WA_ATTR_KEY = 'tara_wa_attribution_v1';
  function waAttribution() {
    if (!analyticsAllowed()) {
      try { window.localStorage.removeItem(WA_ATTR_KEY); } catch (_) {}
      return {};
    }
    var value = readJson(WA_ATTR_KEY);
    var params = new URLSearchParams(window.location.search);
    var token = params.get('wa_tid') || '';
    var now = Date.now();
    if (/^[A-Za-z0-9_-]{32}$/.test(token)) {
      if (value.wa_tid !== token) value = { wa_tid: token, wa_arrived_at: new Date(now).toISOString() };
      value.expires_at = now + 90 * 86400000;
      value.wa_campaign = String(params.get('utm_campaign') || '').slice(0, 100);
      var card = params.get('utm_content') || '';
      value.wa_card = /^(image|(?:sets|serums)_card_[1-6])$/.test(card) ? card : '';
      value.wa_variant = value.wa_card.split('_')[0];
      var sent = Number(params.get('wa_st'));
      if (Number.isFinite(sent) && sent > 1700000000 && sent * 1000 <= now + 300000) {
        value.wa_send_at = new Date(sent * 1000).toISOString();
        value.wa_send_hour_kw = new Date(sent * 1000 + 10800000).toISOString().slice(0, 13) + ':00';
        value.wa_send_weekday_kw = new Date(sent * 1000 + 10800000).getUTCDay();
      }
      var mid = params.get('wa_mid') || '';
      if (/^[0-9a-f-]{36}$/.test(mid)) value.wa_message_id = mid;
      try { window.localStorage.setItem(WA_ATTR_KEY, JSON.stringify(value)); } catch (_) {}
    }
    if (!value.wa_tid || !value.expires_at || value.expires_at <= now) {
      try { window.localStorage.removeItem(WA_ATTR_KEY); } catch (_) {}
      return {};
    }
    var props = {};
    ['wa_tid', 'wa_message_id', 'wa_campaign', 'wa_card', 'wa_variant', 'wa_send_at', 'wa_send_hour_kw', 'wa_send_weekday_kw', 'wa_arrived_at'].forEach(function (key) {
      if (value[key] !== undefined) props[key] = value[key];
    });
    props.wa_attribution_model = 'last_whatsapp_click_90d';
    return props;
  }

  function captureWhatsAppLanding() {
    var props = waAttribution();
    if (!props.wa_tid || new URLSearchParams(window.location.search).get('wa_tid') !== props.wa_tid) return;
    var key = 'tara_wa_landing_' + props.wa_tid;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, '1');
    } catch (_) {}
    capture('ta_whatsapp_landing', props, { flush: true });
  }

  function visitorId() {
    try {
      var stored = window.localStorage.getItem(VISITOR_ID_KEY);
      if (stored) return stored;
      stored = uuid();
      window.localStorage.setItem(VISITOR_ID_KEY, stored);
      return stored;
    } catch (error) {
      return uuid();
    }
  }

  function writeCookie(name, value, maxAgeSeconds) {
    if (!name || !value) return;
    try {
      var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value)
        + '; Max-Age=' + String(maxAgeSeconds || 31536000)
        + '; Path=/; SameSite=Lax';
      if (window.location.protocol === 'https:') cookie += '; Secure';
      document.cookie = cookie;
    } catch (error) {}
  }

  function writeVisitorCookie(id) {
    writeCookie('tara_visitor_id', id, 31536000);
  }

  function directSessionId() {
    if (window.posthog && typeof window.posthog.get_session_id === 'function') {
      var sessionId = window.posthog.get_session_id();
      if (sessionId) return String(sessionId);
    }
    return '';
  }

  function posthogDistinctId() {
    if (window.posthog && typeof window.posthog.get_distinct_id === 'function') {
      var distinctId = window.posthog.get_distinct_id();
      if (distinctId) return String(distinctId);
    }
    return '';
  }

  function canonicalDistinctId() {
    return visitorId();
  }

  function textOf(element) {
    if (!element) return '';
    var text = element.getAttribute('aria-label')
      || element.getAttribute('title')
      || element.getAttribute('value')
      || element.textContent
      || '';
    return String(text).replace(/\s+/g, ' ').trim().slice(0, 140);
  }

  function safeText(value, maxLength) {
    value = String(value || '').replace(/\s+/g, ' ').trim();
    if (!value) return '';
    if (/@/.test(value) || (/^\+?\d[\d\s().-]{8,}$/.test(value) && /[+().\s-]/.test(value))) return '[redacted]';
    return value.slice(0, maxLength || 140);
  }

  function selectedFormValue(form, name) {
    if (!form || !form.querySelector) return '';
    var field = form.querySelector('[name="' + name + '"]');
    if (!field) return '';
    return safeText(field.value || field.getAttribute('value') || '', 120);
  }

  function closestLabel(element) {
    var parent = element && element.closest
      ? element.closest('section, header, footer, main, [id], [data-section-id], [data-section-type], [class*="product"], [class*="cart"]')
      : null;
    if (!parent) return '';
    return (
      parent.getAttribute('id')
      || parent.getAttribute('data-section-id')
      || parent.getAttribute('data-section-type')
      || parent.className
      || ''
    ).toString().slice(0, 180);
  }

  function safeUrl(url) {
    try {
      var parsed = new URL(url || window.location.href, window.location.origin);
      [
        'email',
        'e',
        'phone',
        'name',
        'first_name',
        'last_name',
        'address',
        'customer',
        'token',
        'password',
        'pass',
        'checkout_token',
        'reset_password_token',
        'activation_token'
      ].forEach(function (key) {
        parsed.searchParams.delete(key);
      });
      return parsed.href;
    } catch (error) {
      return '';
    }
  }

  function safePathOrUrl(url) {
    if (!url) return '';
    if (/^mailto:/i.test(url)) return 'mailto:[redacted]';
    if (/^tel:/i.test(url)) return 'tel:[redacted]';
    if (/wa\.me|whatsapp/i.test(url)) return '[whatsapp_link]';
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol === 'mailto:') return 'mailto:[redacted]';
      if (parsed.protocol === 'tel:') return 'tel:[redacted]';
      if (/wa\.me|whatsapp/i.test(parsed.href)) return '[whatsapp_link]';
      return safeUrl(parsed.href);
    } catch (error) {
      return '';
    }
  }

  function captureOnce(name, key, props, options) {
    key = name + ':' + String(key || 'default');
    if (oneTimeEvents[key]) return;
    oneTimeEvents[key] = true;
    capture(name, props, options);
  }

  function elementContext(element) {
    if (!element) return {};
    return {
      element_tag: element.tagName ? element.tagName.toLowerCase() : '',
      element_id: element.getAttribute ? safeText(element.getAttribute('id') || '', 120) : '',
      element_class: element.className ? safeText(String(element.className), 160) : '',
      element_text: textOf(element),
      element_location: closestLabel(element)
    };
  }

  function linkType(href) {
    href = String(href || '');
    if (!href) return '';
    if (/wa\.me|whatsapp/i.test(href)) return 'whatsapp';
    if (/^mailto:/i.test(href)) return 'email';
    if (/^tel:/i.test(href)) return 'phone';
    if (/\/checkout(?:\/|\?|$)/i.test(href)) return 'checkout';
    if (/\/cart(?:\/|\?|$)/i.test(href)) return 'cart';
    if (/\/account(?:\/|\?|$)/i.test(href)) return 'account';
    if (/\/search(?:\/|\?|$)/i.test(href)) return 'search';
    if (/\/pages\/(?:consultation-results|quiz-results)(?:[/?#]|$)/i.test(href)) return 'consultation_results';
    if (/\/pages\/(?:consultation|quiz)(?:[/?#]|$)/i.test(href)) return 'consultation';
    if (/\/products\//i.test(href)) return 'product';
    if (/\/collections\//i.test(href)) return 'collection';
    try {
      var parsed = new URL(href, window.location.origin);
      if (parsed.origin !== window.location.origin) return 'external';
    } catch (error) {}
    return 'internal';
  }

  function dialogKind(element) {
    if (!element || !element.closest) return '';
    var dialog = element.matches && element.matches('dialog') ? element : element.querySelector && element.querySelector('dialog');
    var source = [element, dialog].filter(Boolean).map(function (node) {
      return [
        node.id,
        node.getAttribute && node.getAttribute('aria-label'),
        node.getAttribute && node.getAttribute('data-dialog-type'),
        node.className
      ].join(' ');
    }).join(' ').toLowerCase();
    if (source.indexOf('cart') !== -1) return 'cart';
    if (source.indexOf('search') !== -1) return 'search';
    if (source.indexOf('menu') !== -1 || source.indexOf('drawer') !== -1) return 'menu';
    if (source.indexOf('quick-add') !== -1) return 'quick_add';
    if (source.indexOf('zoom') !== -1 || source.indexOf('media') !== -1) return 'media_zoom';
    return 'dialog';
  }

  function serializeFilterParams(params) {
    var summary = {
      filter_count: 0,
      filters: [],
      sort_by: '',
      search_query: ''
    };
    try {
      params.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0) {
          summary.filter_count += 1;
          summary.filters.push((key + '=' + value).slice(0, 140));
        } else if (key === 'sort_by') {
          summary.sort_by = safeText(value, 80);
        } else if (key === 'q') {
          summary.search_query = safeText(value, 120);
        }
      });
    } catch (error) {}
    summary.filters = summary.filters.slice(0, 20);
    return summary;
  }

  function attrValue(attribution, touch, key) {
    if (!attribution) return '';
    if (attribution[key]) return attribution[key];
    if (attribution[touch] && attribution[touch][key]) return attribution[touch][key];
    return '';
  }

  function contextValue(attribution, key) {
    if (!attribution) return '';
    if (attribution[key]) return attribution[key];
    if (attribution.context && attribution.context[key]) return attribution.context[key];
    return '';
  }

  function sessionValue(session, key) {
    if (!session) return '';
    return session[key] || session['attribution_' + key] || '';
  }

  function normalizeSource(source, clickIds) {
    source = String(source || '').toLowerCase();
    clickIds = clickIds || {};
    if (
      source.indexOf('facebook') !== -1
      || source.indexOf('instagram') !== -1
      || source === 'fb'
      || source === 'ig'
      || source === 'meta'
      || clickIds.fbclid
    ) return 'meta';
    if (source.indexOf('tiktok') !== -1 || source === 'tt' || clickIds.ttclid) return 'tiktok';
    if (source.indexOf('google') !== -1 || source === 'adwords' || clickIds.gclid) return 'google';
    if (source.indexOf('pinterest') !== -1 || source === 'pin') return 'pinterest';
    if (source) return source;
    return 'direct_or_unknown';
  }

  function attributionQuality(props) {
    if (props.last_utm_source || props.last_utm_campaign || props.last_utm_content) return 'utm';
    if (props.last_fbclid || props.last_gclid || props.last_ttclid || props.last_msclkid) return 'click_id';
    if (props.referrer || props.session_entry_referrer || props.last_referrer) return 'referrer';
    return 'direct_or_unknown';
  }

  function viewportProps() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
    return {
      viewport_width: window.innerWidth || 0,
      viewport_height: window.innerHeight || 0,
      screen_width: window.screen && window.screen.width,
      screen_height: window.screen && window.screen.height,
      device_pixel_ratio: window.devicePixelRatio || 1,
      connection_effective_type: connection.effectiveType || '',
      connection_save_data: !!connection.saveData
    };
  }

  function queryParams() {
    var params = {};
    try {
      var search = new URLSearchParams(window.location.search);
      [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'utm_id',
        'utm_adset_id',
        'utm_ad_id',
        'campaign_id',
        'adset_id',
        'ad_id',
        'discount',
        'offer',
        'fbclid',
        'gclid',
        'ttclid',
        'msclkid'
      ].forEach(function (key) {
        var value = search.get(key);
        if (value) params[key] = value.slice(0, 300);
      });
    } catch (error) {}
    return params;
  }

  function hasQaMarker(value) {
    value = String(value || '').toLowerCase();
    return /^codex_/.test(value)
      || /^qa_/.test(value)
      || value.indexOf('taraposthogprobe') !== -1
      || value.indexOf('tarapixel') !== -1
      || value.indexOf('tarastorageprobe') !== -1
      || value.indexOf('taracheckoutprobe') !== -1
      || value.indexOf('playwright') !== -1
      || value.indexOf('headlesschrome') !== -1;
  }

  function isInternalQa(props) {
    var params = queryParams();
    var ua = window.navigator && window.navigator.userAgent ? window.navigator.userAgent : '';
    return hasQaMarker(ua)
      || /(?:[?&])(?:ta_debug|posthog_debug|attribution_debug)=1(?:&|$)/.test(window.location.search)
      || hasQaMarker(params.utm_campaign)
      || hasQaMarker(params.utm_content)
      || hasQaMarker(params.utm_term)
      || hasQaMarker(props && props.utm_campaign)
      || hasQaMarker(props && props.last_utm_campaign)
      || hasQaMarker(props && props.first_utm_campaign);
  }

  function qaRunId(props) {
    var candidates = [
      props && props.qa_run_id,
      props && props.utm_campaign,
      props && props.last_utm_campaign,
      props && props.first_utm_campaign,
      props && props.utm_content,
      props && props.last_utm_content
    ];
    for (var index = 0; index < candidates.length; index += 1) {
      if (hasQaMarker(candidates[index])) return String(candidates[index]).slice(0, 180);
    }
    return '';
  }

  function detectOfferCode() {
    var code = '';
    try {
      var pathMatch = window.location.pathname.match(/\/discount\/([^\/\?#]+)/i);
      if (pathMatch && pathMatch[1]) code = decodeURIComponent(pathMatch[1]);
      if (!code) {
        var params = new URLSearchParams(window.location.search);
        code = params.get('discount') || params.get('offer') || '';
      }
      code = String(code || '').trim().slice(0, 80);
      if (code) window.sessionStorage.setItem('tara_offer_code_v1', code);
      if (!code) code = window.sessionStorage.getItem('tara_offer_code_v1') || '';
    } catch (error) {}
    return code;
  }

  function baseProps(extra) {
    var attribution = readJson(ATTRIBUTION_KEY);
    var session = readJson(SESSION_KEY, window.sessionStorage);
    var id = canonicalDistinctId();
    var sdkDistinctId = posthogDistinctId();
    var props = Object.assign({
      tara_tracking_version: VERSION,
      tracking_schema_version: VERSION,
      tara_visitor_id: id,
      canonical_distinct_id: id,
      posthog_distinct_id: id,
      posthog_sdk_distinct_id: sdkDistinctId,
      posthog_session_id: directSessionId(),
      page_url: safeUrl(window.location.href),
      page_path: window.location.pathname,
      page_title: document.title,
      page_type: config.pageType || '',
      template_name: config.templateName || '',
      template_suffix: config.templateSuffix || '',
      canonical_url: config.canonicalUrl || '',
      referrer: safeUrl(document.referrer),
      first_landing_url: attrValue(attribution, 'first', 'first_landing_url'),
      first_landing_path: attrValue(attribution, 'first', 'first_landing_path'),
      first_referrer: attrValue(attribution, 'first', 'first_referrer'),
      first_utm_source: attrValue(attribution, 'first', 'first_utm_source'),
      first_utm_medium: attrValue(attribution, 'first', 'first_utm_medium'),
      first_utm_campaign: attrValue(attribution, 'first', 'first_utm_campaign'),
      first_utm_content: attrValue(attribution, 'first', 'first_utm_content'),
      first_utm_term: attrValue(attribution, 'first', 'first_utm_term'),
      first_utm_id: attrValue(attribution, 'first', 'first_utm_id'),
      first_utm_adset_id: attrValue(attribution, 'first', 'first_utm_adset_id'),
      first_utm_ad_id: attrValue(attribution, 'first', 'first_utm_ad_id'),
      first_campaign_id: attrValue(attribution, 'first', 'first_campaign_id'),
      first_adset_id: attrValue(attribution, 'first', 'first_adset_id'),
      first_ad_id: attrValue(attribution, 'first', 'first_ad_id'),
      first_fbclid: attrValue(attribution, 'first', 'first_fbclid'),
      first_gclid: attrValue(attribution, 'first', 'first_gclid'),
      first_ttclid: attrValue(attribution, 'first', 'first_ttclid'),
      first_msclkid: attrValue(attribution, 'first', 'first_msclkid'),
      first_timestamp: attrValue(attribution, 'first', 'first_timestamp'),
      last_landing_url: attrValue(attribution, 'last', 'last_landing_url'),
      last_landing_path: attrValue(attribution, 'last', 'last_landing_path'),
      last_referrer: attrValue(attribution, 'last', 'last_referrer'),
      last_utm_source: attrValue(attribution, 'last', 'last_utm_source'),
      last_utm_medium: attrValue(attribution, 'last', 'last_utm_medium'),
      last_utm_campaign: attrValue(attribution, 'last', 'last_utm_campaign'),
      last_utm_content: attrValue(attribution, 'last', 'last_utm_content'),
      last_utm_term: attrValue(attribution, 'last', 'last_utm_term'),
      last_utm_id: attrValue(attribution, 'last', 'last_utm_id'),
      last_utm_adset_id: attrValue(attribution, 'last', 'last_utm_adset_id'),
      last_utm_ad_id: attrValue(attribution, 'last', 'last_utm_ad_id'),
      last_campaign_id: attrValue(attribution, 'last', 'last_campaign_id'),
      last_adset_id: attrValue(attribution, 'last', 'last_adset_id'),
      last_ad_id: attrValue(attribution, 'last', 'last_ad_id'),
      last_fbclid: attrValue(attribution, 'last', 'last_fbclid'),
      last_gclid: attrValue(attribution, 'last', 'last_gclid'),
      last_ttclid: attrValue(attribution, 'last', 'last_ttclid'),
      last_msclkid: attrValue(attribution, 'last', 'last_msclkid'),
      last_timestamp: attrValue(attribution, 'last', 'last_timestamp'),
      attribution_fbp: contextValue(attribution, 'attribution_fbp'),
      attribution_fbc: contextValue(attribution, 'attribution_fbc'),
      session_entry_url: sessionValue(session, 'session_entry_url'),
      session_entry_path: sessionValue(session, 'session_entry_path'),
      session_entry_referrer: sessionValue(session, 'session_referrer'),
      shop_domain: config.shopDomain || '',
      currency: config.currency || '',
      market: config.market || '',
      language: config.language || ''
    }, viewportProps(), queryParams(), waAttribution(), extra || {});

    props.active_offer_code = detectOfferCode();
    props.normalized_last_source = normalizeSource(props.last_utm_source || props.utm_source, {
      fbclid: props.last_fbclid || props.fbclid,
      gclid: props.last_gclid || props.gclid,
      ttclid: props.last_ttclid || props.ttclid
    });
    props.normalized_first_source = normalizeSource(props.first_utm_source, {
      fbclid: props.first_fbclid,
      gclid: props.first_gclid,
      ttclid: props.first_ttclid
    });
    props.attribution_quality = attributionQuality(props);
    props.is_paid_traffic = props.last_utm_medium === 'paid_social'
      || props.last_utm_medium === 'cpc'
      || props.last_utm_medium === 'paid_search'
      || props.utm_medium === 'paid_social'
      || props.utm_medium === 'cpc'
      || props.utm_medium === 'paid_search'
      || !!(props.last_fbclid || props.last_gclid || props.last_ttclid || props.fbclid || props.gclid || props.ttclid);
    props.is_internal_qa = isInternalQa(props);
    props.qa_run_id = props.is_internal_qa ? qaRunId(props) : '';

    return props;
  }

  function posthogEndpoint(path) {
    return config.apiHost.replace(/\/$/, '') + path;
  }

  function sendSingleEvents(events, keepalive) {
    return Promise.all(events.map(function (eventPayload) {
      var body = JSON.stringify(Object.assign({ api_key: config.projectKey }, eventPayload));
      return fetch(posthogEndpoint('/capture/'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: !!keepalive && body.length < 60000
      }).catch(function () {});
    }));
  }

  function sendEvents(events, keepalive) {
    if (!events.length) return Promise.resolve(false);
    var batchBody = JSON.stringify({
      api_key: config.projectKey,
      batch: events
    });

    return fetch(posthogEndpoint('/batch/'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: batchBody,
      keepalive: !!keepalive && batchBody.length < 60000
    }).then(function (response) {
      if (!response.ok) throw new Error('PostHog batch failed: ' + response.status);
      return true;
    }).catch(function () {
      return sendSingleEvents(events, keepalive).then(function () {
        return false;
      });
    });
  }

  function flushEvents(keepalive) {
    window.clearTimeout(flushTimer);
    flushTimer = null;
    if (!analyticsAllowed()) { eventQueue = []; return Promise.resolve(false); }
    if (!eventQueue.length) return Promise.resolve(false);
    var events = eventQueue.splice(0, eventQueue.length);
    return sendEvents(events, keepalive);
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = window.setTimeout(function () {
      flushEvents(false);
    }, FLUSH_DELAY_MS);
  }

  function capture(name, props, options) {
    if (!analyticsAllowed()) return;
    options = options || {};
    var properties = baseProps(props);
    properties.$current_url = properties.page_url;
    properties.$pathname = properties.page_path;
    properties.$lib = 'tara-shopify-theme';

    var distinctId = properties.canonical_distinct_id || canonicalDistinctId();
    var sdkDistinctId = posthogDistinctId();
    var sessionId = directSessionId();

    if (distinctId) {
      properties.$device_id = distinctId;
      properties.posthog_distinct_id = distinctId;
      properties.canonical_distinct_id = distinctId;
      properties.tara_visitor_id = distinctId;
    }

    if (sdkDistinctId) {
      properties.posthog_sdk_distinct_id = sdkDistinctId;
    }

    if (sessionId) {
      properties.$session_id = sessionId;
      properties.posthog_session_id = sessionId;
    }

    eventQueue.push({
      event: name,
      distinct_id: distinctId,
      properties: properties,
      timestamp: new Date().toISOString()
    });

    if (options.flush || eventQueue.length >= MAX_BATCH_EVENTS) {
      flushEvents(!!options.keepalive);
      return;
    }

    scheduleFlush();
  }

  function cartUpdateUrl() {
    var route = window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url
      ? window.Theme.routes.cart_update_url
      : window.theme && window.theme.routes && window.theme.routes.cart_update_url
        ? window.theme.routes.cart_update_url
        : '/cart/update';

    if (/\.js(?:\?|$)/.test(route)) return route;
    return route.replace(/\/$/, '') + '.js';
  }

  function attributionCartAttributes() {
    var attribution = readJson(ATTRIBUTION_KEY);
    var attributes = {};

    function addValue(key, value) {
      if (value === undefined || value === null || value === '') return;
      attributes[key] = String(value).slice(0, 700);
    }

    function addGroup(group) {
      Object.keys(group || {}).forEach(function (key) {
        var cartKey = CART_ATTRIBUTE_MAP[key] || (key.indexOf('tara_') === 0 ? key : 'tara_' + key);
        addValue(cartKey, group[key]);
      });
    }

    addGroup(attribution.first);
    addGroup(attribution.last);
    addGroup(attribution.context);
    addGroup(waAttribution());
    if (!attributes.tara_fbclid) {
      addValue('tara_fbclid', attrValue(attribution, 'first', 'first_fbclid'));
    }

    return attributes;
  }

  function syncPostHogCartAttributes(reason, keepalive) {
    if (!analyticsAllowed()) return Promise.resolve(false);
    var id = canonicalDistinctId();
    if (!id) return Promise.resolve(false);

    var attributes = attributionCartAttributes();
    var qaProps = baseProps({ cart_sync_reason: reason || '' });
    attributes.tara_tracking_schema_version = VERSION;
    attributes.tara_canonical_distinct_id = String(id).slice(0, 300);
    attributes.tara_visitor_id = String(id).slice(0, 300);
    attributes.tara_posthog_distinct_id = String(id).slice(0, 300);
    attributes.tara_is_internal_qa = qaProps.is_internal_qa ? 'true' : 'false';
    if (qaProps.qa_run_id) attributes.tara_qa_run_id = qaProps.qa_run_id;
    var sdkDistinctId = posthogDistinctId();
    if (sdkDistinctId) attributes.tara_posthog_sdk_distinct_id = sdkDistinctId.slice(0, 300);

    var offerCode = detectOfferCode();
    if (offerCode) attributes.tara_offer_code = offerCode;

    var sessionId = directSessionId();
    if (sessionId) attributes.tara_posthog_session_id = sessionId.slice(0, 300);

    var signature = JSON.stringify(attributes);
    try {
      if (window.sessionStorage.getItem(POSTHOG_CART_SYNC_KEY) === signature) {
        return Promise.resolve(false);
      }
    } catch (error) {}

    var body = JSON.stringify({ attributes: attributes });
    var options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: body
    };
    if (keepalive && body.length < 60000) options.keepalive = true;

    return fetch(cartUpdateUrl(), options)
      .then(function (response) {
        if (!response.ok) return false;
        try {
          window.sessionStorage.setItem(POSTHOG_CART_SYNC_KEY, signature);
        } catch (error) {}
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function loadPostHog() {
    var id = canonicalDistinctId();
    writeVisitorCookie(id);

    window.posthog = window.posthog || [];
    if (!window.posthog.__SV) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.crossOrigin = 'anonymous';
      script.async = true;
      script.src = config.apiHost.replace(/\/$/, '').replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      window.posthog._i = [];
      window.posthog.init = function (token, options, name) {
        function factory(method) {
          return function () {
            window.posthog.push([method].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var methods = 'capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group resetGroups setPersonPropertiesForFlags'.split(' ');
        var instance = window.posthog;
        if (name) instance = window.posthog[name] = [];
        instance.people = instance.people || [];
        methods.forEach(function (method) {
          var target = method.indexOf('people.') === 0 ? instance.people : instance;
          target[method.replace('people.', '')] = factory(method);
        });
        window.posthog._i.push([token, options, name]);
      };
      window.posthog.__SV = 1;
    }

    window.posthog.init(config.projectKey, {
      api_host: config.apiHost,
      defaults: '2026-01-30',
      capture_pageview: false,
      capture_pageleave: false,
      autocapture: false,
      person_profiles: 'identified_only',
      disable_session_recording: config.sessionRecording === false,
      bootstrap: {
        distinctID: id
      },
      session_recording: {
        maskAllInputs: true,
        maskInputOptions: {
          password: true,
          email: true,
          tel: true,
          text: true,
          textarea: true,
          select: true
        },
        maskTextSelector: '[data-ta-mask], [data-customer-fields], form[action*="/account"], form[action*="/contact"], form[action*="/checkout"], input, textarea, select, [contenteditable="true"]',
        blockSelector: '[data-ta-no-capture], iframe, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .shopify-payment-button__button'
      },
      loaded: function () {
        try {
          writeCookie('tara_posthog_distinct_id', id, 31536000);
          writeCookie('tara_posthog_sdk_distinct_id', posthogDistinctId(), 31536000);
          writeCookie('tara_posthog_session_id', directSessionId(), 1800);
          window.posthog.register({
            tara_visitor_id: id,
            canonical_distinct_id: id,
            posthog_distinct_id: id,
            posthog_sdk_distinct_id: posthogDistinctId(),
            tracking_schema_version: VERSION,
            shop_domain: config.shopDomain || ''
          });
        } catch (error) {}
        syncPostHogCartAttributes('loaded', false);
        window.setTimeout(function () {
          writeCookie('tara_posthog_session_id', directSessionId(), 1800);
          syncPostHogCartAttributes('session_ready_retry', false);
        }, 1500);
        window.setTimeout(function () {
          writeCookie('tara_posthog_session_id', directSessionId(), 1800);
          syncPostHogCartAttributes('session_ready_final', false);
        }, 5000);
      }
    });
  }

  function captureInitialPageContext() {
    var session = readJson(SESSION_KEY, window.sessionStorage);
    capture('ta_page_viewed', {
      product_id: config.product && config.product.id,
      product_handle: config.product && config.product.handle,
      product_title: config.product && config.product.title,
      product_vendor: config.product && config.product.vendor,
      product_type: config.product && config.product.type,
      product_price: config.product && config.product.price,
      product_variant_id: config.product && config.product.variantId,
      product_available: config.product && config.product.available,
      collection_id: config.collection && config.collection.id,
      collection_handle: config.collection && config.collection.handle,
      collection_title: config.collection && config.collection.title
    });
    var landingKey = 'tara_landing_page_viewed_v1';
    var shouldTrackLanding = (session.attribution_session_entry_path || session.session_entry_path || '') === window.location.pathname;
    try {
      shouldTrackLanding = shouldTrackLanding || !window.sessionStorage.getItem(landingKey);
      if (shouldTrackLanding) window.sessionStorage.setItem(landingKey, '1');
    } catch (error) {}
    if (shouldTrackLanding) {
      capture('ta_landing_page_viewed', {
        landing_page: window.location.pathname,
        landing_url: safeUrl(window.location.href)
      });
    }
    if (config.product) {
      capture('ta_product_viewed', {
        product_id: config.product.id,
        product_handle: config.product.handle,
        product_title: config.product.title,
        product_vendor: config.product.vendor,
        product_type: config.product.type,
        product_price: config.product.price,
        product_variant_id: config.product.variantId,
        product_available: config.product.available
      });
    }
    if (config.collection) {
      capture('ta_collection_viewed', {
        collection_id: config.collection.id,
        collection_handle: config.collection.handle,
        collection_title: config.collection.title
      });
    }
  }

  function isCheckoutTarget(target) {
    if (!target || !target.getAttribute) return false;
    var href = target.getAttribute('href') || '';
    var formAction = target.getAttribute('formaction') || '';
    return /\/checkout(?:\/|\?|$)/.test(href)
      || /\/checkout(?:\/|\?|$)/.test(formAction)
      || target.getAttribute('name') === 'checkout'
      || target.matches('shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
      || !!target.closest('[data-lp-checkout-form]');
  }

  function isProductCta(target) {
    if (!target || !target.closest) return false;
    return !!target.closest('form[action*="/cart/add"], product-form-component, quick-add-component, .product-form, .quick-add');
  }

  function bindClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('a, button, input[type="submit"], [role="button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
        : null;
      if (!target) return;

      var href = target.getAttribute('href') || '';
      var isCheckout = isCheckoutTarget(target);
      var type = linkType(href);
      var productCta = isProductCta(target);
      var productRecommendation = target.closest('[data-ta-product-recommendation], product-card, .product-card, [data-product-handle]');
      capture(isCheckout ? 'ta_checkout_cta_clicked' : 'ta_cta_clicked', {
        cta_text: textOf(target),
        cta_href: href ? safePathOrUrl(href) : '',
        cta_location: closestLabel(target),
        link_type: type,
        is_product_cta: productCta,
        is_checkout_cta: isCheckout
      }, { flush: isCheckout, keepalive: isCheckout });
      if (productCta) {
        lastAddToCartClickAt = Date.now();
        capture('ta_add_to_cart_clicked', {
          cta_text: textOf(target),
          cta_location: closestLabel(target),
          product_id: config.product && config.product.id,
          product_handle: config.product && config.product.handle,
          product_title: config.product && config.product.title
        });
      }
      if (productRecommendation) {
        capture('ta_product_recommendation_clicked', productCardData(productRecommendation));
      }
      if (isCheckout) {
        lastCheckoutStartAt = Date.now();
      }
      if (type && type !== 'internal') {
        capture('ta_navigation_clicked', Object.assign(elementContext(target), {
          link_type: type,
          link_href: safePathOrUrl(href)
        }));
        capture('ta_outbound_link_clicked', Object.assign(elementContext(target), {
          link_type: type,
          link_href: safePathOrUrl(href)
        }));
      }
      if (type === 'whatsapp') {
        capture('ta_whatsapp_clicked', Object.assign(elementContext(target), { link_href: safePathOrUrl(href) }));
      } else if (type === 'email' || type === 'phone') {
        capture('ta_contact_link_clicked', Object.assign(elementContext(target), {
          contact_type: type,
          link_href: safePathOrUrl(href)
        }));
      } else if (type === 'account') {
        capture('ta_account_link_clicked', Object.assign(elementContext(target), { link_href: safePathOrUrl(href) }));
      }
      if (target.closest('search-button, [class*="search"], [aria-controls*="search"]')) {
        capture('ta_search_opened', elementContext(target));
      }
      if (isCheckout) syncPostHogCartAttributes('checkout_click', true);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      var action = form.getAttribute('action') || '';

      if (/\/search(?:\?|$|\/)/.test(action) || form.querySelector('input[type="search"], input[name="q"]')) {
        capture('ta_search_submitted', {
          form_action: safePathOrUrl(action),
          search_query: selectedFormValue(form, 'q'),
          search_location: closestLabel(form)
        });
        return;
      }

      if (/\/localization(?:\?|$|\/)/.test(action)) {
        capture('ta_localization_submitted', {
          form_action: safePathOrUrl(action),
          selected_country: selectedFormValue(form, 'country_code'),
          selected_language: selectedFormValue(form, 'locale_code'),
          localization_location: closestLabel(form)
        });
        return;
      }

      if (form.matches('[data-lp-checkout-form]')) {
        syncPostHogCartAttributes('direct_checkout_submit', true);
        capture('ta_direct_checkout_submitted', {
          form_action: action,
          variant_id: form.getAttribute('data-lp-variant-id') || ''
        }, { flush: true, keepalive: true });
        return;
      }

      if (isEmailCaptureForm(form)) {
        capture('ta_email_capture_submitted', {
          form_action: action,
          capture_context: form.getAttribute('data-ta-lead-capture-context') || '',
          capture_location: closestLabel(form)
        });
        return;
      }

      if (/\/cart\/add/.test(action) || form.querySelector('[name="id"]')) {
        syncPostHogCartAttributes('cart_add_submit', true);
        if (Date.now() - lastAddToCartClickAt > 1000) {
          capture('ta_add_to_cart_clicked', {
            form_action: action,
            variant_id: (form.querySelector('[name="id"]') || {}).value || '',
            product_id: config.product && config.product.id,
            product_handle: config.product && config.product.handle,
            product_title: config.product && config.product.title
          });
        }
        capture('ta_add_to_cart_submitted', {
          form_action: action,
          variant_id: (form.querySelector('[name="id"]') || {}).value || '',
          product_id: config.product && config.product.id,
          product_handle: config.product && config.product.handle,
          product_title: config.product && config.product.title
        });
      }
    }, true);

    document.addEventListener('cart:update', function (event) {
      syncPostHogCartAttributes('cart_update', true);
      var data = event && event.detail && event.detail.data ? event.detail.data : {};
      capture('ta_cart_updated', {
        cart_event_source: data.source || '',
        item_count: data.itemCount || '',
        variant_id: data.variantId || '',
        product_id: data.productId || '',
        did_error: !!data.didError
      });
      if (data.variantId || Date.now() - lastAddToCartClickAt < 15000) {
        capture('ta_add_to_cart_completed', {
          cart_event_source: data.source || '',
          variant_id: data.variantId || '',
          item_count: data.itemCount || ''
        });
        capture('ta_add_to_cart_submitted', {
          cart_event_source: data.source || '',
          variant_id: data.variantId || '',
          item_count: data.itemCount || ''
        });
      }
    });

    document.addEventListener('focusin', function (event) {
      var form = event.target && event.target.closest ? event.target.closest('form') : null;
      if (!form || !isEmailCaptureForm(form)) return;
      var key = form.getAttribute('id') || closestLabel(form) || 'email-capture';
      captureOnce('ta_email_capture_started', key, {
        capture_context: form.getAttribute('data-ta-lead-capture-context') || '',
        capture_location: closestLabel(form)
      });
    }, true);

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;

      if (target.matches('select[name="sort_by"]')) {
        capture('ta_sort_changed', Object.assign(elementContext(target), {
          sort_by: safeText(target.value, 80)
        }));
        return;
      }

      if (target.matches('input[name^="filter."], select[name^="filter."]')) {
        capture('ta_filter_input_changed', Object.assign(elementContext(target), {
          filter_name: safeText(target.name, 120),
          filter_value: safeText(target.value, 120),
          filter_checked: target.checked === undefined ? '' : !!target.checked
        }));
      }
    }, true);
  }

  function bindThemeEvents() {
    document.addEventListener('variant:selected', function (event) {
      var resource = event.detail && event.detail.resource ? event.detail.resource : {};
      capture('ta_variant_selected', {
        option_value_id: safeText(resource.id || '', 120),
        variant_location: closestLabel(event.target)
      });
    });

    document.addEventListener('variant:update', function (event) {
      var resource = event.detail && event.detail.resource ? event.detail.resource : {};
      var data = event.detail && event.detail.data ? event.detail.data : {};
      capture('ta_variant_updated', {
        variant_id: resource.id || '',
        variant_available: resource.available === undefined ? '' : !!resource.available,
        variant_sku_present: !!resource.sku,
        product_id: data.productId || '',
        new_product_id: data.newProduct && data.newProduct.id ? data.newProduct.id : '',
        new_product_url: data.newProduct && data.newProduct.url ? safePathOrUrl(data.newProduct.url) : '',
        variant_location: closestLabel(event.target)
      });
    });

    document.addEventListener('quantity-selector:update', function (event) {
      var detail = event.detail || {};
      capture('ta_quantity_changed', {
        quantity: detail.quantity,
        cart_line: detail.cartLine || '',
        quantity_location: closestLabel(event.target)
      });
    });

    document.addEventListener('cart:error', function (event) {
      var data = event.detail && event.detail.data ? event.detail.data : {};
      capture('ta_cart_error', {
        source_id: event.detail && event.detail.sourceId ? event.detail.sourceId : '',
        message_present: !!data.message,
        errors_present: !!data.errors,
        description_present: !!data.description
      });
    });

    document.addEventListener('discount:update', function (event) {
      var resource = event.detail && event.detail.resource ? event.detail.resource : {};
      capture('ta_discount_updated', {
        source_id: event.detail && event.detail.sourceId ? event.detail.sourceId : '',
        discount_count: resource.discount_codes && resource.discount_codes.length ? resource.discount_codes.length : '',
        cart_item_count: resource.item_count || '',
        cart_total_price: resource.total_price || ''
      });
    });

    document.addEventListener('filter:update', function (event) {
      var detail = event.detail || {};
      var params = detail.urlParameters || detail.resource || detail;
      capture('ta_filter_changed', serializeFilterParams(params));
    });

    document.addEventListener('media:started-playing', function (event) {
      capture('ta_media_started', Object.assign(elementContext(event.target), {
        media_location: closestLabel(event.target)
      }));
    });

    document.addEventListener('zoom-media:selected', function (event) {
      capture('ta_product_media_selected', {
        media_index: event.detail && event.detail.index !== undefined ? event.detail.index : event.detail,
        media_location: closestLabel(event.target)
      });
    });

    document.addEventListener('dialog:open', function (event) {
      var kind = dialogKind(event.target);
      capture('ta_dialog_opened', Object.assign(elementContext(event.target), { dialog_kind: kind }));
      if (kind === 'cart') capture('ta_cart_viewed', { cart_view_source: 'dialog_open', cart_location: closestLabel(event.target) });
      if (kind === 'search') capture('ta_search_opened', { search_open_source: 'dialog_open', search_location: closestLabel(event.target) });
    }, true);

    document.addEventListener('dialog:close', function (event) {
      capture('ta_dialog_closed', Object.assign(elementContext(event.target), { dialog_kind: dialogKind(event.target) }));
    }, true);

    document.addEventListener('toggle', function (event) {
      var target = event.target;
      if (!window.HTMLDetailsElement || !(target instanceof HTMLDetailsElement)) return;
      capture('ta_accordion_toggled', Object.assign(elementContext(target), {
        accordion_open: !!target.open,
        accordion_summary: textOf(target.querySelector('summary'))
      }));
    }, true);
  }

  function bindMediaEngagement() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('media-gallery button, slideshow-controls button, slideshow-arrows button, .product-media button, .product-media a, deferred-media button, video')
        : null;
      if (!target) return;
      capture('ta_product_media_clicked', Object.assign(elementContext(target), {
        media_location: closestLabel(target)
      }));
    }, true);

    document.addEventListener('play', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('video, audio')) {
        capture('ta_media_started', Object.assign(elementContext(target), {
          media_type: target.tagName.toLowerCase(),
          media_location: closestLabel(target)
        }));
      }
    }, true);
  }

  function bindCartVisibility() {
    if (!('IntersectionObserver' in window)) return;
    if (!/\/cart(?:\/|\?|$)/.test(window.location.pathname)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.4) return;
        var element = entry.target;
        captureOnce('ta_cart_viewed', element.tagName + ':' + closestLabel(element), {
          cart_view_source: 'visible',
          cart_location: closestLabel(element)
        });
      });
    }, { threshold: [0.4] });
    document.querySelectorAll('cart-items-component, form[action="/cart"], form[action$="/cart"], form[action*="/cart?"]').forEach(function (element) {
      observer.observe(element);
    });
  }

  function bindSearchResultClicks() {
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var inSearch = !!link.closest('predictive-search-component, [data-search-results], .predictive-search, .search-results, form[action*="/search"]');
      if (!inSearch && window.location.pathname.indexOf('/search') === -1) return;
      capture('ta_search_result_clicked', Object.assign(elementContext(link), {
        result_href: safePathOrUrl(link.getAttribute('href') || ''),
        result_type: linkType(link.getAttribute('href') || '')
      }));
    }, true);
  }

  function bindConsultationJourney() {
    var root = document.querySelector('tara-consultation, .consultation-section, [data-consultation-config]');
    if (!root && window.location.pathname.indexOf('/pages/consultation') === -1) return;

    function activeStepName(element) {
      var step = element && element.closest ? element.closest('[data-step]') : null;
      return step ? step.getAttribute('data-step') || '' : '';
    }

    function trackVisibleSteps() {
      document.querySelectorAll('.consultation-step[data-step]').forEach(function (step) {
        if (step.hidden || step.getAttribute('aria-hidden') === 'true') return;
        var rect = step.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return;
        var name = step.getAttribute('data-step') || '';
        captureOnce('ta_consultation_step_viewed', name, {
          consultation_step: name,
          consultation_step_location: closestLabel(step)
        });
      });
    }

    trackVisibleSteps();
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(trackVisibleSteps);
      observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'aria-hidden', 'data-ready'] });
    }

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('[data-intake-submit], [data-adaptive-text-submit], [data-contact-submit], [data-contact-skip], .consultation-option, [data-tara-retake], [data-tara-shop-all], [data-copy-consultation-link]')
        : null;
      if (!target) return;

      if (target.matches('[data-intake-submit]')) {
        capture('ta_consultation_anchor_submitted', { consultation_step: activeStepName(target) });
      } else if (target.matches('[data-adaptive-text-submit]')) {
        capture('ta_consultation_text_answer_submitted', { consultation_step: activeStepName(target) });
      } else if (target.matches('.consultation-option')) {
        var options = target.parentElement ? Array.prototype.slice.call(target.parentElement.querySelectorAll('.consultation-option')) : [];
        capture('ta_consultation_option_selected', {
          consultation_step: activeStepName(target),
          option_index: options.indexOf(target) + 1,
          option_count: options.length
        });
      } else if (target.matches('[data-contact-submit]')) {
        var input = document.querySelector('[data-contact-input]');
        var inputType = input && input.getAttribute('data-phone') !== null ? 'phone' : 'email_or_phone';
        capture('ta_consultation_contact_submitted', { consultation_step: activeStepName(target), contact_method: inputType });
      } else if (target.matches('[data-contact-skip]')) {
        capture('ta_consultation_contact_skipped', { consultation_step: activeStepName(target) });
      } else if (target.matches('[data-tara-retake]')) {
        capture('ta_consultation_retake_clicked', elementContext(target));
      } else if (target.matches('[data-tara-shop-all]')) {
        capture('ta_consultation_shop_all_clicked', elementContext(target));
      } else if (target.matches('[data-copy-consultation-link]')) {
        capture('ta_consultation_result_link_copied', elementContext(target));
      }
    }, true);

    document.addEventListener('tara:consultation-data-ready', function (event) {
      var state = event.detail && event.detail.state ? event.detail.state : {};
      capture('ta_consultation_results_ready', {
        assessment_id_present: !!state.assessment_id,
        recommended_products_count: state.products && state.products.length ? state.products.length : '',
        recommended_bundle_handle: safeText(state.bundle_handle || '', 120)
      });
    });

    document.addEventListener('tara:consultation-data-empty', function () {
      capture('ta_consultation_results_empty', {});
    });
  }

  function bindConsultationAnalyticsBridge() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var analytics = window.TaraConsultationAnalytics;
      if (!analytics || typeof analytics.track !== 'function') {
        if (attempts > 40) window.clearInterval(timer);
        return;
      }
      // TaraConsultationAnalytics is frozen, so it cannot be wrapped: the
      // assignment below threw on every 250 ms tick for the whole visit.
      // Starts and completions are captured from consultation DOM events
      // (anchor submitted, results ready) instead.
      if (analytics.__taraPostHogWrapped || Object.isFrozen(analytics)) {
        window.clearInterval(timer);
        return;
      }

      var originalTrack = analytics.track;
      analytics.track = function (instance, eventName, data) {
        var result = originalTrack.apply(this, arguments);
        var payload = data || {};
        var safePayload = {
          consultation_event_name: eventName,
          question_count: payload.question_count || payload.question_number || payload.total_questions || '',
          total_questions: payload.total_questions || '',
          contact_type: payload.contact_type || '',
          content_name: safeText(payload.content_name || '', 120)
        };

        if (eventName === 'ConsultationStarted') {
          captureOnce('ta_consultation_started', 'consultation-started', safePayload);
        } else if (eventName === 'ConsultationProgress') {
          capture('ta_consultation_step_viewed', safePayload);
        } else if (eventName === 'ConsultationCompleted') {
          captureOnce('ta_consultation_completed', 'consultation-completed', safePayload, { flush: true, keepalive: true });
        }

        return result;
      };
      analytics.__taraPostHogWrapped = true;
      window.clearInterval(timer);
    }, 250);
  }

  function bindPageEngagement() {
    var startedAt = Date.now();
    var engaged = false;
    window.setTimeout(function () {
      engaged = true;
      captureOnce('ta_page_engaged', window.location.pathname, {
        engaged_after_seconds: 10
      });
    }, 10000);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'hidden') return;
      capture('ta_page_left', {
        engaged_time_seconds: Math.max(0, Math.round((Date.now() - startedAt) / 1000)),
        reached_engaged_threshold: engaged
      }, { flush: true, keepalive: true });
    });
  }

  function bindFlushLifecycle() {
    window.addEventListener('pagehide', function () {
      flushEvents(true);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushEvents(true);
    });
  }

  function bindScrollDepth() {
    function onScroll() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop || 0;
      var height = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var depth = Math.round((scrollTop / height) * 100);
      SCROLL_DEPTHS.forEach(function (target) {
        if (depth >= target && !scrollSeen[target]) {
          scrollSeen[target] = true;
          capture('ta_scroll_depth_reached', { scroll_depth: target });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function bindSectionViews() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
        var element = entry.target;
        var key = element.getAttribute('id')
          || element.getAttribute('data-section-id')
          || element.getAttribute('data-section-type')
          || element.className
          || '';
        key = key.toString().slice(0, 180);
        if (!key || sectionSeen[key]) return;
        sectionSeen[key] = true;
        capture('ta_section_viewed', {
          section_key: key,
          section_text_sample: textOf(element).slice(0, 220)
        });
      });
    }, { threshold: [0.35] });

    document.querySelectorAll('section, .shopify-section, [id^="shopify-section-"], main > div').forEach(function (element) {
      observer.observe(element);
    });
  }

  function isProductRecommendation(element) {
    if (!element || !element.matches) return false;
    return element.matches('[data-ta-product-recommendation], product-card, .product-card, [data-product-handle]');
  }

  function productCardData(element) {
    var link = element.querySelector && element.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') || '' : '';
    var handle = element.getAttribute('data-product-handle') || '';
    if (!handle && href) {
      try {
        handle = new URL(href, window.location.origin).pathname.split('/products/')[1] || '';
      } catch (error) {}
    }
    return {
      product_handle: handle.split(/[?#/]/)[0],
      product_title: element.getAttribute('data-product-title') || textOf(link || element),
      product_price: element.getAttribute('data-product-price') || '',
      recommendation_location: closestLabel(element)
    };
  }

  function checkoutCandidateData(element) {
    return {
      form_id: element.getAttribute('id') || '',
      variant_id: element.getAttribute('data-lp-variant-id') || ((element.querySelector && element.querySelector('[name="id"]')) || {}).value || '',
      checkout_candidate_type: element.matches && element.matches('[data-lp-checkout-form]') ? 'direct_checkout_form' : (
        element.matches && element.matches('shopify-accelerated-checkout, shopify-accelerated-checkout-cart') ? 'accelerated_checkout' : 'checkout_control'
      ),
      cta_location: closestLabel(element)
    };
  }

  function addToCartCandidateData(element) {
    return {
      form_id: element.getAttribute('id') || '',
      variant_id: element.getAttribute('data-lp-variant-id') || ((element.querySelector && element.querySelector('[name="id"]')) || {}).value || '',
      product_handle: element.getAttribute('data-product-handle') || '',
      cta_location: closestLabel(element)
    };
  }

  function isAddToCartVisibilityElement(element) {
    if (!element || !element.matches) return false;
    return element.matches('form[action*="/cart/add"], product-form-component, quick-add-component, .product-form, .quick-add')
      || !!(element.querySelector && element.querySelector('form[action*="/cart/add"], button[name="add"], input[name="add"], [data-add-to-cart]'));
  }

  function isCheckoutVisibilityElement(element) {
    if (!element || !element.matches) return false;
    return element.matches('[data-lp-checkout-form], form[action*="/checkout"], button[name="checkout"], input[name="checkout"], a[href*="/checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
      || !!(element.querySelector && element.querySelector('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart'));
  }

  function isEmailCaptureForm(form) {
    return !!(form && form.querySelector && form.querySelector('input[type="email"], input[name*="email" i]'));
  }

  function collectEmailCaptureElements() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-ta-lead-capture], [data-klaviyo-form-id]'));
    Array.prototype.slice.call(document.querySelectorAll('form')).forEach(function (form) {
      if (isEmailCaptureForm(form) && nodes.indexOf(form) === -1) nodes.push(form);
    });
    return nodes;
  }

  function bindDecisionViews() {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
        var element = entry.target;
        var key = element.getAttribute('id')
          || element.getAttribute('data-product-handle')
          || element.getAttribute('data-klaviyo-form-id')
          || element.className
          || textOf(element);
        key = key.toString().slice(0, 180);
        if (!key || seen[key]) return;
        seen[key] = true;

        if (isProductRecommendation(element)) {
          capture('ta_product_recommendation_viewed', productCardData(element));
          capture('ta_product_recommendation_seen', productCardData(element));
        }

        if (isAddToCartVisibilityElement(element)) {
          capture('ta_add_to_cart_cta_visible', addToCartCandidateData(element));
        }

        if (isCheckoutVisibilityElement(element)) {
          capture('ta_checkout_cta_visible', checkoutCandidateData(element));
        }

        if (element.matches('[data-ta-lead-capture], [data-klaviyo-form-id]') || isEmailCaptureForm(element)) {
          capture('ta_email_capture_visible', {
            capture_context: element.getAttribute('data-ta-lead-capture-context') || '',
            capture_location: closestLabel(element),
            capture_text: textOf(element).slice(0, 220)
          });
        }
      });
    }, { threshold: [0.45] });

    document.querySelectorAll('[data-ta-product-recommendation], product-card, .product-card, [data-product-handle], form[action*="/cart/add"], product-form-component, quick-add-component, .product-form, .quick-add, [data-lp-checkout-form], form[action*="/checkout"], button[name="checkout"], input[name="checkout"], a[href*="/checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart').forEach(function (element) {
      observer.observe(element);
    });
    collectEmailCaptureElements().forEach(function (element) {
      observer.observe(element);
    });
  }

  function bindKlaviyoForms() {
    window.addEventListener('klaviyoForms', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var formId = detail.formId || detail.formID || '';
      var formHost = formId ? document.querySelector('[data-klaviyo-form-id="' + formId + '"]') : null;
      var metadata = detail.metaData || {};
      var submittedFields = [];
      try {
        submittedFields = Object.keys(metadata).filter(function (key) {
          return !/email|phone|name|address/i.test(key);
        });
      } catch (error) {}

      var props = {
        klaviyo_event_type: detail.type || '',
        klaviyo_form_id: formId,
        klaviyo_company_id: detail.companyId || detail.companyID || '',
        capture_context: formHost ? formHost.getAttribute('data-ta-lead-capture-context') || '' : '',
        capture_location: formHost ? closestLabel(formHost) : '',
        submitted_field_keys: submittedFields
      };

      if (detail.type === 'submit') {
        capture('ta_email_capture_submitted', props);
      } else if (detail.type === 'stepSubmit') {
        capture('ta_email_capture_step_submitted', props);
      } else if (detail.type === 'embedOpen' || detail.type === 'open') {
        capture('ta_email_capture_opened', props);
      }
    });
  }

  if (!analyticsAllowed()) return;
  loadPostHog();
  captureInitialPageContext();
  captureWhatsAppLanding();
  bindFlushLifecycle();
  bindClicks();
  bindThemeEvents();
  bindMediaEngagement();
  bindCartVisibility();
  bindSearchResultClicks();
  bindConsultationJourney();
  bindConsultationAnalyticsBridge();
  bindPageEngagement();
  bindScrollDepth();
  bindSectionViews();
  bindDecisionViews();
  bindKlaviyoForms();
})();
